import React from 'react';
import { Outlet } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import Section from '../components/common/Section';
import Logo from '../components/navbar/Logo';

const ErrorLayout = () => (
  <Section className="py-0">
    <Row className="flex-center min-vh-100 py-6">
      <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
        <Logo />
        <Outlet />
      </Col>
    </Row>
  </Section>
);

export default ErrorLayout;
